import { createCavernScene } from "./cavernSceneFactory";
import {
  DEEP_GALLERY_SCENE_KEY,
  RUNE_HOLLOW_SCENE_KEY,
  WEST_GROTTO_SCENE_KEY,
  WEST_PASSAGE_SCENE_KEY,
  WEST_PASSAGE_SCENE_ROUTING,
} from "./westPassageRoutes";

const buildScene = (sceneKey) =>
  createCavernScene({
    sceneKey,
    ...WEST_PASSAGE_SCENE_ROUTING[sceneKey],
  });

export const WestPassageScene = buildScene(WEST_PASSAGE_SCENE_KEY);
export const WestGrottoScene = buildScene(WEST_GROTTO_SCENE_KEY);
export const RuneHollowScene = buildScene(RUNE_HOLLOW_SCENE_KEY);
export const DeepGalleryScene = buildScene(DEEP_GALLERY_SCENE_KEY);
